import { useI18n } from "vue-i18n";
import { useApi } from "@/services/useApi";

export function useExecuteApi() {
  const { t } = useI18n();

  const executeApi = async ({
    requestFactory,
    requestArgs = [],
    dataPath = "data",
    message = {},
    requireData = false,
  }) => {
    const successMessage = message.success
      ? t(message.success)
      : t("common.api.success");

    const errorMessage = message.error
      ? t(message.error)
      : t("common.api.error");

    try {
      const request = requestFactory(...requestArgs);

      const res = await useApi(
        request,
        (response) => ({
          success: true,
          data: response?.data ?? null,
          message: successMessage,
          raw: response,
        }),
        undefined,
        (failureMessage) => ({
          success: false,
          data: null,
          message: failureMessage || errorMessage,
          raw: null,
        }),
      );

      if (!res?.success) {
        return {
          success: false,
          data: null,
          message: res?.message || errorMessage,
          raw: res?.raw ?? res ?? null,
        };
      }

      const data = resolvePath(res, dataPath);

      if (requireData && data == null) {
        return {
          success: false,
          data: null,
          message: errorMessage,
          raw: res.raw ?? res,
        };
      }

      return {
        success: true,
        data,
        message: successMessage,
        raw: res.raw ?? res,
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: errorMessage,
        error,
      };
    }
  };

  return {
    executeApi,
  };
}

function resolvePath(object, path) {
  return path.split(".").reduce((value, key) => value?.[key], object);
}
